import script from "./Develop.vue?vue&type=script&setup=true&lang=ts"
export * from "./Develop.vue?vue&type=script&setup=true&lang=ts"

import "./Develop.vue?vue&type=style&index=0&id=62e712ee&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e712ee"]])

export default __exports__